export default "__VITE_ASSET__TUFPwXXN__"